const inlineMenu = document.querySelector(".header__inline-menu");
if (inlineMenu) { // Check if the element exists to prevent errors
    const detailsItems = inlineMenu.querySelectorAll("details");
    detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul");
        if (ulElement) { // Check if the ul element exists
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
        });
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        }
    });
}

setTimeout(function() {
    var windowsize = $(window).width();
    console.log(windowsize);
    if(windowsize <  990){

        function waitForElement(selector, callback) {
        const interval = setInterval(function() {
            const element = $(selector);
                if (element.length) {
                    clearInterval(interval);
                    callback(element);
                }
            }, 100); // Check every 100ms
        }

        // Usage:
        waitForElement('.related-products ul.product-grid', function(element) {
            console.log('Element found:', element);
            element.addClass('highlighted');
            reloadSlider();
        });
        
        function reloadSlider(){
        console.log($('.related-products-slider').length);
        $('.related-products-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            arrows: false,
            dots: true,
            centerPadding: '10px'
        });
        }
        
        $(window).resize(function(){
        reloadSlider();
        });
        
    }
}, 200);

$('input[name="quantity_sticky"]').change(function() {
    var qty = $(this).val();
    console.log('Input value changed to: ' + qty);
    $('input[name="quantity"]').val(qty);
});

$('input[name="quantity"]').change(function() {
    var qty = $(this).val();
    console.log('Input value changed to: ' + qty);
    $('input[name="quantity_sticky"]').val(qty);
});

$('button.sticky-atc-btn').click(function() {
    $('.product-form button.product-form__submit').click();
  setTimeout(function() {
    
    var notifyText = $('.wrapp-btn-buy .wr-alert-qty').html();
    $('.sticky_notify').html(notifyText)
  }, 700);
});

$('button.product-form__submit').click(function() {
    console.log('product-form__submit main click');
  setTimeout(function() {
    var notifyText = $('.wrapp-btn-buy .wr-alert-qty').html();
    $('.sticky_notify').html(notifyText)
  }, 700);
});

/*
function productComplementaryATC(product_id) {
    console.log(product_id);
    
    const variantID = document.querySelector(".product_complementary_" + product_id).value;
    const atcButton = document.querySelector("#product_complementary_atc-" + product_id + " button.add-to-cart");
    
    if (atcButton) atcButton.classList.add("btn--loading");

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let sections = [];
    
    if (cart && typeof cart.getSectionsToRender === 'function') {
        sections = cart.getSectionsToRender().map((section) => section.id);
    }

    let formData = {
        items: [{
            id: Number(variantID),
            quantity: 1
        }],
        sections: sections 
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(responseData => {
        document.dispatchEvent(new CustomEvent("cart:build"));

        if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(responseData);
        }

        if (atcButton) atcButton.classList.remove("btn--loading");

        if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
        }

        setTimeout(function() {
            const cartIcon = document.querySelector("#cart-icon-bubble");
            if (cartIcon) cartIcon.click();
        }, 300);
    })
    .catch(error => {
        console.error("Error:", error);
        if (atcButton) atcButton.classList.remove("btn--loading");
    });
}


*/

